import { StyleSheet, Text, View } from 'react-native'
import React from 'react'
import { Theme, ThemedText, ThemedView } from '@app/theme'
import ShieldCheckIcon from '@app/assets/svg/ShieldCheckIcon'
import { useTheme } from '@shopify/restyle'

const SecureFetchBadge = () => {
    const {colors} = useTheme<Theme>()
    return (
        <ThemedView mt='md' borderRadius='sm' paddingVertical='sm' paddingHorizontal='md' backgroundColor='bg-fill-emphasis-secondary' flexDirection='row' alignItems='center'>
            <ShieldCheckIcon size={18} color={colors['icon-emphasis-secondary']}/>
            <ThemedText ml='sm' color='text-primary' variant='b4r'>Your bank accounts were securely fetched from MFCentral</ThemedText>
        </ThemedView>
    )
}

export default SecureFetchBadge

const styles = StyleSheet.create({})